import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import blog1Styles from './Blog1Styles';
import Navbar from "../../../../components/Navbar/Navbar";
import Footer from "../../../../components/Footer/Footer";
import CTA from "../../../../components/CTA/CTA";

type Blog1Props = {

};

const StyledBlog1 = styled('section')(({ theme }) => blog1Styles);

const Blog1: React.FC<Blog1Props> = () => (
  <Fragment>
    <Navbar fixedScrolled/>
    <StyledBlog1 className="pt-8 lg:py-0">
      <main className="pt-0 lg:pt-[8rem] antialiased">
        <div id="blog-container" className="py-16 rounded-lg flex justify-between px-8 mx-auto max-w-screen-xl ">
          <article className="mx-auto w-full max-w-4xl format format-sm sm:format-base lg:format-lg format-blue">
            <header className="mb-4 lg:mb-6 not-format">
              <address className="flex items-center mb-6 not-italic">
                <div className="inline-flex items-center mr-3 text-sm text-gray-900">
                  <img loading="lazy" className="mr-4 w-16 h-16 rounded-full" src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Alejandra Gayosso" />
                  <div>
                    <a href="#" rel="author" className="text-xl font-bold text-gray-900">Alejandra Gayosso</a>
                    <p className="text-base text-gray-500">Directora Administrativa</p>
                    <p className="text-base text-gray-500"><time title="February 8th, 2022">Jun 10, 2025</time></p>
                  </div>
                </div>
              </address>
              <h1 className="text-3xl font-extrabold leading-tight text-gray-900 lg:text-4xl">Requisitos y mejores prácticas para transportar carga en México en 2025</h1>
              <p>
              Transportar carga en México en 2025 exige cumplir normas actualizadas, cuidar la
              seguridad y optimizar rutas. Esta guía reúne la documentación, regulaciones
              y estrategias más importantes para que tu operación sea eficiente y sin riesgos.
              </p>
              </header>


               <section>
                <h2>Documentación obligatoria para circular</h2>
                <p>
                Para operar legalmente, las empresas y operadores deben contar con:
                </p>
                <ul>
                <li>Licencia Federal o Estatal vigente, según el tipo de ruta.</li>
                <li>Tarjeta de circulación actualizada del tracto y de la caja seca.</li>
                <li>Póliza de seguro que cubra daños, robo y responsabilidad civil.</li>
                <li>Factura o comprobante fiscal de la mercancía transportada.</li>
                <li>Carta porte digital, obligatoria para la mayoría de traslados.</li>
                </ul>
                <p>
                Mantener un expediente digital actualizado puede acelerar auditorías y revisiones.
                </p>
                </section>


                <section>
                <h2>Normativas vigentes en México en 2025</h2>
                <p>
                La Secretaría de Infraestructura, Comunicaciones y Transportes (SICT) y
                autoridades estatales supervisan el cumplimiento de normas clave como:
                </p>
                <ul>
                <li>NOM-012-SCT: Límites de peso y dimensiones.</li>
                <li>NOM-068-SCT: Condiciones físico-mecánicas de los vehículos.</li>
                <li>NOM-087-SCT: Horarios y tiempos de conducción del operador.</li>
                <li>Restricciones de acceso a zonas metropolitanas y horarios específicos.</li>
                </ul>
                <p>
                Respetar estas normas reduce riesgos de multas y mejora la vida útil del equipo.
                </p>
                </section>


                <section>
                <h2>Seguridad operacional y prevención de riesgos</h2>
                <p>
                La seguridad se mantiene como prioridad en 2025. Entre las mejores prácticas
                destacan:
                </p>
                <ul>
                <li>Inspección de frenos, luces, llantas y cierres de puerta antes de cada viaje.</li>
                <li>Sellado correcto de la carga y uso de candados especializados.</li>
                <li>Monitoreo GPS en tiempo real para prevenir robos.</li>
                <li>Protocolos de reacción ante incidentes en ruta.</li>
                <li>Capacitación continua en manejo defensivo.</li>
                </ul>
                </section>


                <section>
                <h2>Optimización operativa y logística</h2>
                <p>
                Para mejorar eficiencia y reducir costos:
                </p>
                <ul>
                <li>Planifica rutas considerando peajes, tráfico y horarios permitidos.</li>
                <li>Coordina ventanas de carga y descarga para evitar tiempos muertos.</li>
                <li>Utiliza plataformas de rastreo y comunicación interna.</li>
                <li>Evalúa indicadores como costo por kilómetro y tiempo por ruta.</li>
                </ul>
                </section>


                <footer>
                <p>
                En Grupo GM ofrecemos cajas secas en óptimas condiciones y asistencia para que
                tu operación cumpla con toda la normatividad vigente.
                </p>
                </footer>
                </article>
        </div>
      </main>
    
    <CTA
      title="Envíanos tu carga y solicita asesoría gratis"
      description="Envíanos tu carga y solicita asesoría gratis"
      buttonText="Llámanos"
    />
    <aside id="blog-related-articles" aria-label="Related articles" className="flex pt-8 pb-16 lg:py-24 bg-gray-50">
      <div className="px-4 mx-auto max-w-screen-xl">
        <h2 className="mb-8 text-2xl font-bold text-gray-900">Artículos relacionados</h2>
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://wp.tyt.com.mx/wp-content/uploads/2025/05/tractocamion-sobrecarga-1024x597.jpg" className="mb-5 w-full rounded-lg" alt="Guía completa para elegir la caja seca ideal según tu tipo de carga" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Guía completa para elegir la caja seca ideal según tu tipo de carga</a>
            </h2>
            <p className="mb-4 text-gray-500">En esta guía te explicamos las diferencias entre cajas secas de 48 y 53 pies, cuándo conviene usar una plataforma o una cama baja, y qué factores debes considerar antes de rentar.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Read in 2 minutes
            </a>
          </article>
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://logistiko.es/wp-content/uploads/2023/11/logistica-de-almacen.webp" className="mb-5 w-full rounded-lg" alt="Cómo ahorrar costos logísticos rentando cajas secas en lugar de comprarlas" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Cómo ahorrar costos logísticos rentando cajas secas en lugar de comprarlas</a>
            </h2>
            <p className="mb-4  text-gray-500">En este artículo te mostramos porque muchas empresas buscan reducir costos sin afectar la operación.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Lea en 10 minutos
            </a>
          </article>
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://www.poderyfinanzas.com/wp-content/uploads/2023/03/pexels-quintin-gellar-2199293-scaled.jpg" className="mb-5 w-full rounded-lg" alt="Errores comunes al rentar una caja seca y cómo evitarlos" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Errores comunes al rentar una caja seca y cómo evitarlos</a>
            </h2>
            <p className="mb-4  text-gray-500">En este artículo platicamos sobre los errores comunes al rentar una caja seca y cómo evitarlos.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Lea en 4 minutos
            </a>
          </article>
          <article className="max-w-xs">
            <a href="#">
              <img loading="lazy" src="https://a.travel-assets.com/findyours-php/viewfinder/images/res70/225000/225737-Monumental-Clock-Of-Pachuca.jpg?impolicy=fcrop&w=400&h=225&q=mediumLow" className="mb-5 w-full rounded-lg" alt="Zonas estratégicas de operación en Hidalgo y centro del país: ventajas logísticas y rutas clave" />
            </a>
            <h2 className="mb-2 mt-2 text-xl font-bold leading-tight text-gray-900">
              <a href="#">Zonas estratégicas de operación en Hidalgo y centro del país: ventajas logísticas y rutas clave</a>
            </h2>
            <p className="mb-4  text-gray-500">En este artículo hacemos un recorrido de las zonas estratégicas de operación en Hidalgo y centro del país.</p>
            <a href="#" className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 hover:no-underline">
              Lea en 8 minutos
            </a>
          </article>
        </div>
      </div>
    </aside>
    </StyledBlog1>
    <Footer />
  </Fragment>
);

export default Blog1;